import { useMediaQuery } from 'react-responsive';

import VARS from 'css/export-vars.module.scss';

export default function useIsSmallSoftphone() {
  return useMediaQuery({ query: `(max-width: ${VARS.softphoneSmallWidth})` });
}
